import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const CookieBanner: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const hasCookieConsent = localStorage.getItem('cookie-consent');
    if (!hasCookieConsent) {
      setIsVisible(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookie-consent', 'accepted');
    setIsVisible(false);
  };

  const declineCookies = () => {
    localStorage.setItem('cookie-consent', 'declined');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-red-600 text-white p-4 z-50 shadow-lg">
      <div className="container mx-auto">
        <div className="flex flex-col md:flex-row md:items-center justify-between">
          <div className="mr-8 mb-4 md:mb-0">
            <p className="text-sm md:text-base">
              Wir verwenden Cookies, um Ihnen das beste Nutzererlebnis zu bieten. 
              Weitere Informationen finden Sie in unserer{' '}
              <Link to="/cookiepolicy" className="underline hover:text-gray-300">
                Cookie-Richtlinie
              </Link>.
            </p>
          </div>
          <div className="flex space-x-4">
            <button
              onClick={declineCookies}
              className="px-4 py-2 border border-white text-white hover:bg-white hover:text-black transition-colors rounded text-sm"
            >
              Ablehnen
            </button>
            <button
              onClick={acceptCookies}
              className="px-4 py-2 bg-white text-black hover:bg-gray-200 transition-colors rounded text-sm"
            >
              Akzeptieren
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;